import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./search-start-date.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./search-start-date.component.scss?ngResource";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input } from "@angular/core";
import { ApplicationSearchConstants } from "../application-search-constants";
import { NgbCalendar, NgbDate, NgbDateParserFormatter } from "@ng-bootstrap/ng-bootstrap";
import { FormControl, FormGroup } from "@angular/forms";
import { Subject, take } from "rxjs";
import { ApplicationSearchService } from "../../shared/application-search.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SaShortDatePipe } from "../../../../shared/pipes/sa-short-date/sa-short-date.pipe";
import { AppControllerService } from "../../../../app-controller.service";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { AlertType } from "../../../../shared/models/alert";
import { AutoUnsub } from "../../../../shared/decorators/autounsub.decorator";
import { Store } from "@ngrx/store";
import { takeUntil } from "rxjs/operators";
let SearchStartDateComponent = class SearchStartDateComponent {
    calendar;
    formatter;
    applicationSearchService;
    aflaModuleStrategyService;
    saShortDatePipe;
    appController;
    store;
    _destroy$ = new Subject();
    noOfMonthsToDisplay;
    startDateFormControl = ApplicationSearchConstants.FORM_CONTROLS.startDateFormControl;
    fromStartDateFormControl = ApplicationSearchConstants.FORM_CONTROLS.fromStartDateFormControl;
    toStartDateFormControl = ApplicationSearchConstants.FORM_CONTROLS.toStartDateFormControl;
    toDateLabel = ApplicationSearchConstants.FORM_CONTROLS.toDateLabel;
    searchText = ApplicationSearchConstants.FORM_CONTROLS.searchText;
    datePlaceholder = ApplicationSearchConstants.FORM_CONTROLS.datePlaceholder;
    fromDateLabel;
    fromStartDate;
    toStartDate;
    startDateForm;
    applicationSearchCallback;
    isSelectedToDate = false;
    isDisabledtoStartDate = true;
    hoveredDate = null;
    tabChanged;
    constructor(calendar, formatter, applicationSearchService, aflaModuleStrategyService, saShortDatePipe, appController, store) {
        this.calendar = calendar;
        this.formatter = formatter;
        this.applicationSearchService = applicationSearchService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.saShortDatePipe = saShortDatePipe;
        this.appController = appController;
        this.store = store;
        this.fromStartDate = calendar.getToday();
        this.toStartDate = calendar.getToday();
    }
    ngOnInit() {
        this.setUpForm();
    }
    searchApplication($event) {
        const apps = this.store.select("applicationFormGroup");
        const tabSwitched = this.store.select("applicationTabChanged");
        tabSwitched.pipe(takeUntil(this._destroy$), take(1)).subscribe({
            next: (tab) => {
                this.tabChanged = tab;
            }
        });
        apps.pipe(takeUntil(this._destroy$), take(1)).subscribe(val => {
            if (val != null && this.tabChanged) {
                this.startDateForm = val;
            }
        });
        const fromDate = this.fromStartDate ? new Date(this.fromStartDate.year, this.fromStartDate.month - 1, this.fromStartDate.day) : null;
        if (fromDate)
            fromDate.setDate(fromDate.getDate() - 1);
        const toDate = this.toStartDate && this.noOfMonthsToDisplay > 1 ? new Date(this.toStartDate.year, this.toStartDate.month - 1, this.toStartDate.day)
            : (fromDate ? new Date(this.fromStartDate.year, this.fromStartDate.month - 1, this.fromStartDate.day) : null);
        if (!this.tabChanged) {
            this.applicationSearchCallback(this.applicationSearchService.searchByCreatedDate(Number(this.appController.selectedModuleID), this.aflaModuleStrategyService, this.saShortDatePipe.transform(fromDate), this.saShortDatePipe.transform(toDate)));
        }
    }
    // to be consistent, user must click 'Search' before we trigger the search for applications
    onDateSelection(date) {
        // let doSearch = false;
        if (!this.fromStartDate && !this.toStartDate) {
            this.fromStartDate = date;
            // doSearch = this.noOfMonthsToDisplay === 1;
        }
        else if (this.fromStartDate && !this.toStartDate && date && date.after(this.fromStartDate)) {
            this.toStartDate = date;
            // doSearch = this.noOfMonthsToDisplay > 1;
        }
        else {
            this.fromStartDate = date;
            this.toStartDate = null;
            // doSearch = this.noOfMonthsToDisplay === 1;
        }
        // if (doSearch)
        //   this.searchApplication(null);
    }
    setAutoClose() {
        return this.noOfMonthsToDisplay > 1 ? "'outside'" : true;
    }
    isHovered(date) {
        return this.noOfMonthsToDisplay > 1
            ? this.fromStartDate
                && !this.toStartDate
                && this.hoveredDate
                && date.after(this.fromStartDate)
                && date.before(this.hoveredDate)
            : false;
    }
    isInside(date) {
        return this.toStartDate && date.after(this.fromStartDate) && date.before(this.toStartDate);
    }
    isRange(date) {
        return this.noOfMonthsToDisplay > 1
            ? date.equals(this.fromStartDate)
                || (this.toStartDate && date.equals(this.toStartDate)) || this.isInside(date)
                || this.isHovered(date)
            : false;
    }
    validateInput(currentValue, input) {
        const parsed = this.formatter.parse(input);
        if (!parsed && input !== "") {
            this.appController.showMessage(`${SharedConstants.DATE_INPUT_CONTROL_VALIDATION}`, AlertType.Warning);
            return currentValue;
        }
        return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
    }
    clearDate(dateCtrl) {
        if (dateCtrl === "fromDate")
            this.fromStartDate = null;
        else
            this.toStartDate = null;
    }
    setUpForm() {
        this.startDateForm = new FormGroup({
            fromStartDateFormControl: new FormControl(null)
        });
        if (this.noOfMonthsToDisplay > 1) {
            this.startDateForm.addControl("toStartDateFormControl", new FormControl(null));
        }
        this.fromDateLabel = this.noOfMonthsToDisplay > 1 ? ApplicationSearchConstants.FORM_CONTROLS.fromDateLabel : ApplicationSearchConstants.FORM_CONTROLS.dateLabel;
    }
    static ctorParameters = () => [
        { type: NgbCalendar },
        { type: NgbDateParserFormatter },
        { type: ApplicationSearchService },
        { type: AflaModuleStrategyService },
        { type: SaShortDatePipe },
        { type: AppControllerService },
        { type: Store }
    ];
    static propDecorators = {
        noOfMonthsToDisplay: [{ type: Input }]
    };
};
SearchStartDateComponent = __decorate([
    Component({
        selector: "app-search-start-date",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], SearchStartDateComponent);
export { SearchStartDateComponent };
